import { Result } from "@praha/byethrow"
import { createServerFn } from "@tanstack/react-start"
import {
  savePushSubscription as savePushSubscriptionService,
  deletePushSubscription as deletePushSubscriptionService,
} from "@apps/gwservice/push-subscriptions"
import type { SavePushSubscriptionInput } from "@apps/gwservice/push-subscriptions"
import { withAuth } from "~/features/auth/server/auth"

export const savePushSubscription = createServerFn({
  method: "POST",
})
  .inputValidator((data: SavePushSubscriptionInput) => data)
  .handler(({ data }) =>
    Result.try({
      try: async () => {
        await withAuth(savePushSubscriptionService)(data)
      },
      catch: () => "unexpected server error",
    }),
  )

export const deletePushSubscription = createServerFn({
  method: "POST",
})
  .inputValidator((data: { endpoint: string }) => data)
  .handler(({ data }) =>
    Result.try({
      try: async () => {
        await withAuth(deletePushSubscriptionService)(data)
      },
      catch: () => "unexpected server error",
    }),
  )
